import config from "../../config/config";
import { useAuthContext } from "../Auth";
import { FC, useEffect, useState } from "react";
import { DefaultGenerics, StreamChat } from "stream-chat";
import { Chat } from "stream-chat-react";

export const ChatProvider: FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [client, setClient] = useState<null | StreamChat<DefaultGenerics>>(
    null
  );
  const { auth, partner } = useAuthContext();

  useEffect(() => {
    if (auth?.id && partner) {
      const client = StreamChat.getInstance(config.streamApiKey);

      client
        .connectUser(
          {
            id: auth.stream_chat_id || "",
            name: auth.name
          },
          auth.stream_chat_token
        )
        .then(() => {
          setClient(client);
        })
        .catch((e) => {
          console.error(e);
        });
    }

    if (client)
      return () => {
        client.disconnectUser();
      };
  }, [auth?.id, partner]);

  if (!client) return children;

  return (
    <Chat client={client} theme="messaging light">
      {children}
    </Chat>
  );
};
